// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPaperAirplane = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M60.1748 10.916C60.5176 11.7318 60.3369 12.529 59.8689 13.0724C45.7356 33.3138 36.4898 55.8967 36.1703 56.598C35.8455 57.3114 35.1337 57.7695 34.3499 57.7695C33.8244 57.7695 33.3142 57.5621 32.9358 57.1837L27.2903 51.5381L21.414 57.4143C21.0314 57.7969 20.5199 58.0001 19.9994 58.0001C18.9008 58.0001 17.9999 57.1086 17.9999 56.0001L17.9999 44.8833C17.9999 44.0005 18.2831 43.1366 18.8239 42.4389C26.752 32.2108 37.4406 23.7561 46.4806 18.8824C47.5893 18.2611 46.7471 16.5958 45.5967 17.0906C34.6925 22.0997 24.7552 29.1214 16.484 37.8071C15.7039 38.6264 14.4107 38.6585 13.6107 37.8586L4.93593 29.1837C4.1628 28.4107 4.15376 27.1601 4.9156 26.3759C5.6537 25.6162 25.371 9.76953 58.3501 9.76953H58.3551C59.131 9.76953 59.8742 10.2007 60.1748 10.916Z" />
    </svg>
  );
};
